import validate from "/usr/src/app/content/n3-spas-f06d3951-59c2-456b-90b0-79f11e3d2b13/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-f06d3951-59c2-456b-90b0-79f11e3d2b13/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}